module.exports = __webpack_public_path__ + "img/source3_15.f84804ff.png";